import $ from 'jquery'

import { Alert } from '../functions'
import hcSticky from 'hc-sticky'
import { Modal } from 'bootstrap'
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import Swiper from 'swiper/bundle'

// eslint-disable-next-line no-undef
const object = vnObject

const pickerEls = document.querySelectorAll('.vn-datepicker')
if (pickerEls) {
  flatpickr('.vn-datepicker', {
    allowInput: true,
    dateFormat: 'd/m/Y',
    locale: French,
  })
}
const modal = document.querySelectorAll('[data-bs-toggle="modal"]')
if (modal.length) {
  ;[...modal].map((modalItem) => {
    new Modal(modalItem)
  })
}

const form = $('.training-form')

if (form.length) {
  form.parsley().on('form:success', function () {
    form.attr('data-success', 'true')
  })

  form.parsley().on('form:error', function () {
    form.attr('data-success', 'false')
  })

  form.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: $form.serialize() + '&action=' + 'vn_training_contact',
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          // window.location = res.data.redirect
        }

        Alert(res.success, res.data.message)

        // res.success && $form[0].reset()
      },
    })
  })
}

const generateAndDownloadPDF = (data) => {
  const button = document.createElement('a')
  const blob = new Blob([data], { type: 'application/pdf' })

  button.href = URL.createObjectURL(blob)
  button.download = $('.s-training').attr('data-name')
  button.click()
  button.remove()
}

const loadingModalEl = document.getElementById('pdf-loading-modal')
let loadingModal
if (loadingModalEl) {
  loadingModal = Modal.getOrCreateInstance(loadingModalEl)
}

$(document).on('click', '[data-generate-pdf="training"]', function () {
  const button = $(this)

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    xhrFields: {
      responseType: 'blob',
    },
    data: {
      action: 'vn_pdf_form',
      pdf_form: object.pdfNonce,
      post_id: button.attr('data-id'),
    },
    beforeSend: () => {
      button.prop('disabled', true)
      loadingModal.show()
    },
    success: (data) => {
      generateAndDownloadPDF(data)

      if ( $('body').hasClass('single-diploma_trainings') ) {
        window.dataLayer.push({
          'event': 'diploma_trainings_pdf_downloaded',
        });
      }
      else if ( $('body').hasClass('single-continuing_trainings') ) {
        window.dataLayer.push({
          'event': 'continuing_trainings_pdf_downloaded',
        });
      }
      else if ( $('body').hasClass('single-region_trainings') ) {
        window.dataLayer.push({
          'event': 'region_trainings_pdf_downloaded',
        });
      }
    },
    complete: () => {
      button.prop('disabled', false)
      loadingModal.hide()
    },
  })
})

const pdfForm = $('.pdf-form')

$('[data-generate-pdf="re-training"]').on('click', function () {
  $('.pdf-modal-section--already-generated').hide()
  //$('.pdf-modal-section--form').show()
  pdfForm.trigger('submit')
})

if (pdfForm.length) {
  pdfForm.parsley().on('form:success', function () {
    pdfForm.attr('data-success', 'true')
  })

  pdfForm.parsley().on('form:error', function () {
    pdfForm.attr('data-success', 'false')
  })

  pdfForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      xhrFields: {
        responseType: 'blob',
      },
      data: $form.serialize() + '&action=' + 'vn_pdf_form',
      beforeSend: () => {
        $('.pdf-modal-section--form').hide()
        $('.pdf-modal-section--generating').show()
      },
      success: (data) => {
        generateAndDownloadPDF(data)

        $('.pdf-modal-section--generating').hide()
        $('.pdf-modal-section--generated').show()

        const formModal = document.getElementById('pdf-modal')
        formModal.addEventListener('hidden.bs.modal', () => {
          $('.pdf-modal-section--generated').hide()
          $('.pdf-modal-section--already-generated').show()
        })

        if ( $('body').hasClass('single-diploma_trainings') ) {
          window.dataLayer.push({
            'event': 'diploma_trainings_pdf_downloaded',
          });
        }
        else if ( $('body').hasClass('single-continuing_trainings') ) {
          window.dataLayer.push({
            'event': 'continuing_trainings_pdf_downloaded',
          });
        }
        else if ( $('body').hasClass('single-region_trainings') ) {
          window.dataLayer.push({
            'event': 'region_trainings_pdf_downloaded',
          });
        }
      },
    })
  })
}

const closeSidebar = () => {
  $('body').removeClass('training-filter-active')
}

$(document).on('click', '.training-summary a', function (e) {
  e.preventDefault()
  const target = $(`#${$(this).attr('href').replace('#', '')}`)

  if (window.matchMedia('(max-width: 991.98px)').matches) {
    closeSidebar()
  }

  target[0].scrollIntoView({ behavior: 'smooth' })
})

let sticky
document.addEventListener('DOMContentLoaded', function () {
  let top = 30

  const adminBar = document.getElementById('wpadminbar')
  if (adminBar) top += adminBar.clientHeight

  const header = document.getElementById('masthead')
  if (header) top += header.clientHeight

  sticky = new hcSticky('.training-sidebar', {
    top,
    bottom: 30,
    responsive: {
      991: {
        disable: true,
      },
    },
  })
})

$('.training-sidebar-accordion').on('click', function () {
  if (sticky) {
    setTimeout(() => {
      sticky.refresh()
    }, 250)
  }
})

$('.training-filter-toggle').on('click', function () {
  $('body').toggleClass('training-filter-active')
})

$('.training-sidebar').on('click', function (e) {
  if (window.matchMedia('(max-width: 991.98px)').matches && this === e.target) {
    $('body').removeClass('training-filter-active')
  }
})

new Swiper('.training-continue-trainings__slider', {
  spaceBetween: 30,
  slidesPerView: 2,
  navigation: {
    prevEl: $('.training-continue-trainings__nav--prev')[0],
    nextEl: $('.training-continue-trainings__nav--next')[0],
  },
  breakpoints: {
    1300: {
      slidesPerView: 3,
    },
  },
})

$('.js-open-pre-register').on('click', function () {
  $('.js-school-input').val($(this).attr('data-school-id'))
  $('#apiPreRegisterModal').modal('show')
})

const preRegisterForm = $('.pre-register-form')

if (preRegisterForm.length) {
  preRegisterForm.parsley().on('form:success', function () {
    preRegisterForm.attr('data-success', 'true')
  })

  preRegisterForm.parsley().on('form:error', function () {
    preRegisterForm.attr('data-success', 'false')
  })

  preRegisterForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)
    const formData = new FormData($(this)[0])
    formData.append('action', 'vn_pre_register')

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          // window.location = res.data.redirect
        }

        Alert(res.success, res.data.message)
        $('#apiPreRegisterModal').modal('hide')
      },
      error: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          // window.location = res.data.redirect
        }

        Alert(res.error, res.data.message)
      },
    })
  })
}
